import { render, staticRenderFns } from "./FisrtForm.vue?vue&type=template&id=0309478b&scoped=true&"
import script from "./FisrtForm.vue?vue&type=script&lang=js&"
export * from "./FisrtForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0309478b",
  null
  
)

export default component.exports